export default {
	BEFORE: 'before',
	AFTER: 'after',
};

/**
 * Return a child node at the defined position
 * @param component - The component that has props for "childrenPosition" and "children"
 * @param position - The position you are placing the children at
 * @return {node}
 */
export function positionChildren(component, position) {
	return (
		position === component.props.childrenPosition && component.props.children ? component.props.children : undefined
	);
}